<template>
  <section class="cheque-queue">
    <h1>Cheque Queue</h1>
    <div class="abs-top-right">
      <v-button
        type="primary"
        @click="onDownload">Download Cheque List</v-button>
    </div>
    <section class="main">
      <el-tabs v-model="status">
        <el-tab-pane
          v-for="(tab, index) in tabList"
          :key="index"
          :label="tab.label"
          :name="tab.name"
        ></el-tab-pane>
      </el-tabs>
      
      <section v-show="status === '1'">
        <div class="text-right">
          <v-button
            :disabled="disabledBtn"
            @click="handlerClearSelection">Clear Selection</v-button>
          <v-button
            :disabled="disabledBtn"
            type="primary"
            @click="markDoneSelection">Mark as Done</v-button>
        </div>
      </section>
      <div class="transparent">
        <el-table
          ref="newTable"
          :data="tableData"
          stripe
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"></el-table-column>
          <el-table-column
            prop="id"
            label="ID"></el-table-column>
          <el-table-column
            prop="name"
            label="Name"></el-table-column>
          <el-table-column
            prop="insurer"
            label="Insurer"></el-table-column>
          <el-table-column
            prop="reason"
            label="Reason"></el-table-column>
          <el-table-column
            prop="policy_no"
            label="Policy No."></el-table-column>
          <el-table-column
            prop="amount"
            label="Amount"></el-table-column>
        </el-table>
      </div>
    </section>
    <v-pagination
      :total="pageConfig.total"
      :current="pageConfig.currentPage"
      :pageSize="pageConfig.pageSize"
      @currentChange="currentChange"
    />
  </section>
</template>
<script>
import { getChequeList, markDoneCheque, downloadChequeList } from '@/api/cheque'
export default {
  name: 'ChequeQueue',
  data() {
    return {
      pageConfig: {
        //  分頁配置
        currentPage: 1,
        total: 10,
        pageSize: 20
      },
      status: '1',
      tabList: [
        {
          label: 'New',
          name: '1'
        },
        {
          label: 'Done',
          name: '4'
        }
      ],
      tableData: [],
      selectionList: []
    }
  },
  computed: {
    idCheckedList() {
      const selectList = this.selectionList.reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      return selectList
    },
    disabledBtn() {
      return this.idCheckedList.length <= 0
    }
  },
  watch: {
    status(val, old) {
      if (val != old) {
        this.pageConfig.currentPage = 1
        this.network().getChequeList()
      }
    }
  },
  created() {
    this.network().getChequeList()
  },
  methods: {
    currentChange(page) {
      this.pageConfig.currentPage = page
      this.network().getChequeList()
    },
    handleSelectionChange(val) {
      this.selectionList = val
    },
    handlerClearSelection() {
      this.$refs.newTable.clearSelection()
    },
    onDownload() {
      this.network().downloadChequeList()
    },
    markDoneSelection() {
      if(this.idCheckedList.length < 1) {
        return
      }
      this.network().markDoneCheque()
    },
    network() {
      return {
        getChequeList: async () => {
          const { data } = await getChequeList({
            status: this.status,
            page: this.pageConfig.currentPage
          })
          this.tableData = data.data
          this.pageConfig.total = data.meta.total
          this.pageConfig.pageSize = data.meta.per_page
        },
        markDoneCheque: async () => {
          const { data } = await markDoneCheque({
            cheque_id: this.idCheckedList
          })
          this.network().getChequeList()
        },
        downloadChequeList: async () => {
          const res = await downloadChequeList({
            status: this.status,
            page: this.pageConfig.currentPage
          })
          const blob = new Blob([res.data])
          const contentDisposition = res.headers['Content-Disposition'] || res.headers['content-disposition']
          const patt = new RegExp('filename=([^;]+\\.[^\\.;]+);*')
          const fileName = patt.exec(contentDisposition)[1]
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = window.URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          window.URL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.cheque-queue {
  position: relative;
  .transparent {
    margin-top: 15px;
  }
  .abs-top-right {
    padding: 15px;
  }
}
</style>